<template>
    <div>
        <MdTitleRegInfo  
            v-bind:RegistrationInfo="{}"  
            v-bind:titlePrefix="'Notes Info'"            
            v-bind:titleRef="'titleElementNotes'">
        </MdTitleRegInfo>

        <p class="iSetupLabel">
            <i class="ikon med-help"></i>
            Check your favorite notes or click to display them. Once complete, hit <b>Save</b> to move forward.
        </p>

        <b-row v-if="this.ProvidersList.length > 1">           
            <b-col lg="3" md="3" sm="12">            
                    <MdSelect
                        v-bind:Label="'Provider'"
                        v-bind:Options="ProvidersList"
                        v-bind:FieldDescription="'companyName'"
                        v-bind:IsDisabled="false"
                        v-bind:AllowEmpty="false"
                        v-bind:FieldCode="'providerCode'"
                        v-bind:Model="Provider"                       
                        v-bind:Multiple="false"
                        :Input="ChangeDropDownProviders"/>
            </b-col> 
            <b-col lg="3" md="3" sm="12" class="d-flex flex-column justify-content-end">  
                <MdButton
                    v-bind:isReadOnly="false"
                    v-bind:Label="'Apply Selection To All Providers'"
                    v-bind:Name="'btnAplySelection'"
                    v-on:click="ApplySelection()"
                    v-bind:ClassProp="'btn-login mb-2'"/>            
            </b-col>
        </b-row>
        

        <b-row>
            <b-col lg="3" md="3" sm="12">            
                    <MdSelect
                        v-bind:Label="'Status'"
                        v-bind:Options="StatusList"
                        v-bind:FieldDescription="'description'"
                        v-bind:IsDisabled="false"
                        v-bind:AllowEmpty="false"
                        v-bind:FieldCode="'code'"
                        v-bind:Model="Status"                       
                        v-bind:Multiple="false"
                        :Input="ChangeDropDownStatus"/>
            </b-col>
            <b-col lg="3" md="3" sm="12">            
                    <MdSelect
                        v-bind:Label="'Category'"
                        v-bind:Options="CategoryList"
                        v-bind:FieldDescription="'description'"
                        v-bind:IsDisabled="false"
                        v-bind:AllowEmpty="false"
                        v-bind:FieldCode="'code'"
                        v-bind:Model="Category"                       
                        v-bind:Multiple="false"
                        :Input="ChangeDropDownCategory"/>
            </b-col>

             <b-col lg="3" md="3" sm="12">            
                    <MdSelect
                        v-bind:Label="'TeleHealth'"
                        v-bind:Options="TeleHealthList"
                        v-bind:FieldDescription="'description'"
                        v-bind:IsDisabled="false"
                        v-bind:AllowEmpty="false"
                        v-bind:FieldCode="'code'"
                        v-bind:Model="TeleHealth"                       
                        v-bind:Multiple="false"
                        :Input="ChangeDropDownTeleHealth"/>
            </b-col>

             <b-col lg="3" md="3" sm="12">            
                 <MdLookup
                    v-bind:Label="'Billing'"
                    v-bind:ModelCode="Billing"
                    v-bind:ModelDescription="bDescription"
                    v-bind:RefCode="'cpt'"
                    v-bind:Api="'CPTs'"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'name'"                    
                    :IsDisabled="false"    
                    :SearchTitle="'Billing'"
                    :GetValues="onCodeConditionOk"                    
                    :SearchFieldCode="'code'"                     
                />
            </b-col>
        </b-row>
        
       <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

        <div class="flex-container">
              <div class="row">                
              
              <div class="col-md-3">
                 <MdCheckBox
                  v-bind:Label="$t('Shared.SelectAll')"
                  v-bind:Name="'SelectTableAll'"
                  v-bind:ClassProp="'AlignCheck mx-3'"
                  v-bind:CheckedValue="true"
                  v-bind:isReadOnly="this.items.length === 0"
                  v-bind:UncheckedValue="false"
                  v-model="UseSelectTableAll" 
                  v-on:change="onChangeSelectAll"                
               /> 
              </div>
              <div class="col-md-3 mt-3">
                <span class="tableSelectedItems"><span class="selItemsVal">{{ SelectedRecords }}</span> {{ $t('claimbatchList.item') }}<span v-if="SelectedRecords != 1">s</span> {{ $t('claimbatchList.selected') }}</span>
              </div>  
             <div class="col-md-6">
                       <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                      <div class="input-group">
                          <input 
                            type="text" 
                            class="form-control"
                            v-model="modelSearch"                          
                            @keyup.enter="FindinItems()"
                          >
                          <div class="input-group-append">
                              <MdButton 
                                v-bind:Name="'btnsearchinput'"
                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                v-bind:IconClass="'mdi mdi-magnify'"                               
                                v-on:click="FindinItems"
                                 >
                              </MdButton>
                          </div>
                      </div>
                  </div>
             </div>
                  
          
                                     
              </div>
          </div>

         
        <MdTablePaginationClient 
            v-bind:fields="fields"
            v-bind:items="items"
            v-bind:totalRows="totalRows"              
            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
            v-bind:currentPage="currentPage"
            v-bind:perPage="perPage" 
            v-bind:SelectAll="UseSelectTableAll"             
            v-bind:pageOptions="pageOptions"
            :iconSelected="IconSelected"
            :viewIconEvent="ViewNote"
            :onFiltered="onFiltered"               
            v-bind:VisibleEditIcon="true"  
            :editIconEvent="Edit"                     
            :onRowSelected="onRowSelected"    
            :pageChanged="pageChanged"
            :RowClick="RowClicked"        
            :perPageFunction="PerPageFunction">                
        </MdTablePaginationClient>

     

        <div class="space-actions"></div>
        <div class="page-actions">

        <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="'◄'"
            v-bind:Name="'btnNotesBack'"
            v-on:click="Back"
            v-bind:ClassProp="'mx-2'"/>

        <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="'►'"
            v-on:click="Next"
            v-bind:Name="'btnnotesNext'"
            v-bind:ClassProp="'mx-2'"/>  

        <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="$t('Shared.Save')"
            v-bind:Name="'btnNotes'"
            v-bind:ClassProp="'mx-2 btn-login'"/>
        </div>

       <IniModalSetupNote
            v-if="showModalNote"
            v-bind:NoteId="FormId"
            v-bind:TitleWindow="'Note design'" 
            @getCodeConditionOK="OnReturnNoteOK($event)"
            @getCodeConditionCANCEL="OnReturnNoteCancel($event)"
             v-bind:ModalId="modalIdNote">
        </IniModalSetupNote>

     <!--<EmployeeInboxNotesModal v-if="showModalNote"
        v-bind:Header="Header"       
        v-bind:ProgramCode="ProgramCode"
        v-bind:CategoryCode="CategoryCode"> 
      </EmployeeInboxNotesModal>-->



    </div>
   

</template>

<script>
import { EventBus } from '@/event-bus.js';
import ISetup from '@/services/isetup.service'
import DBFunctions from '@/common/DBFunctions.js';
import ShowMessage from '@/components/messages/ShowMessage.js'

export default {
  name: 'IniNotes',
   mixins: [ShowMessage, DBFunctions],
  data(){
    return{
        modalIdNote:"OpenIdNoteModal",
        showModalNote:false,
        Header:{},
        params:{      
          NotesID: "",
          HeaderId: "", 
          PatientCode: "",
          TherapyCode: "", 
          TransDate : "",
          AdmissionRecordID: "",
          IsVoid: ""
        },
         parameter:{
            SearchCriteria:"",
          // PageNumber : 0,
           // PageSize:0,
            ProviderCode:"",
            Category:"",
            TeleHealth:false, 
            BillingCode:"", 
            Selected:"" 
        },
        Billing:"",
        bDescription:"",        
        Status:{code:null,description:"All"},
        TeleHealthList:[
            {code:true,description:"Yes"},
            {code:false,description:"No"},
            {code:null,description:"All"}
        ],
        
        StatusList:[
           {code:true,description:"Selected"},
           {code:false,description:"No Selected"},
           {code:null,description:"All"}
        ],
        TeleHealth:{code:null,description:"All"},
        Category:{code:"",description:"All"},
        CategoryList:[
            {code:"MA",description:"Medicare Part A"},
            {code:"MB",description:"Medicare Part B"},
            {code:"MC",description:"Medicaid"},
            {code:"CI",description:"Commercial Insurance Co."},
            {code:"BL",description:"Blue Cross/Blue Shield"},
            {code:"",description:"All"}
        ],
        ProvidersList:[],
        Provider:{providerCode:"",companyName:""},
        FormId:"",
         fields:[
            { key: 'formTitle', sortable: true, label: 'Note Description', class: 'text-rigth' },         
            { key: 'formId', sortable: true, label: '', class: 'text-rigth hidden' },  
            { key: 'formName', sortable: true, label: 'Form Name', class: 'text-rigth' }                          
        ],
        ShowMessageIsEmpty:false,
        items:[           
        ],
        indexSelected : 0,
        SelectedRecords:0,
        UseSelectTableAll:false,
        pageOptions: [5, 10, 15 ],
        totalRows: 0,
        currentPage: 1,
        perPage: 10,
        modelSearch:"",
    }
  },
  methods:{
    Next(){
        this.$router.push({ name:'iapptypes'});
    },

    Back(){
        this.$router.push({ name:'iprograms'}); 
    },

    ChangeDropDownProviders(item){
      this.Provider = item;
      this.parameter.ProviderCode = item.providerCode;
      this.getNotesList();
    },

    onCodeConditionOk(result){
        var type = result.FieldName;  
        console.log(result);     
             switch (type) {
                case "cpt": 
                  this.Billing = result.code; 
                  this.parameter.BillingCode = result.code;                   
                  this.bDescription = result.description; 
                  this.getNotesList();
                  break;
             }
    },

    ApplySelection(){

    },

    ChangeDropDownStatus(item){
      this.Status = item;
      this.parameter.Selected = item.code;
      this.getNotesList();
    },

    ChangeDropDownTeleHealth(item){
      this.TeleHealth = item;
      this.parameter.TeleHealth = item.code;
      this.getNotesList();
    },

    ChangeDropDownCategory(item){
      this.Category = item;
      this.parameter.Category = item.code;
      this.getNotesList();
    },

    Edit(){

    },

    async getProviders(){   
      this.$emit('load', true);   
      await ISetup.getAllSetupProviders()
      .then((response) => {      
           if (response.status == "200") {              
                this.ProvidersList = response.data;
                if(this.ProvidersList.length >= 1){
                    this.Provider.providerCode = this.ProvidersList[0].providerCode;
                    this.parameter.ProviderCode = this.ProvidersList[0].providerCode;
                    this.Provider.companyName = this.ProvidersList[0].companyName;                    
                }
                this.$emit('load', false);
           }
           this.$emit('load', false);
      })
      .catch(error => {
        this.$emit('load', false);
        if (error.response) {
          this.showMessage(this.$tc('Msg.Error'),error,"error");
        }
      });  
    },

    ViewNote(row){   
        this.FormId = row.formId;
        this.showModalNote = true;
        console.log(row);
    },

    OnReturnNoteOK(){
        this.showModalNote = false;
    },

    OnReturnNoteCancel(){
        this.showModalNote = false;
    },

    FindinItems(){

    },

    onFiltered(){

    },

    async getNotesList(){   
      this.$emit('load', true); 
      this.items = [];  
      /*let param = {
        ProviderCode:this.Provider.providerCode,
        TeleHealth:this.TeleHealth.code, 
        BillingCode:this.Billing.code, 
        Selected:this.Status.code,                        
        PageSize: parameter.PageSize,          
        PageNumber : parameter.PageNumber, 
      }*/
      await ISetup.getAllNotes(this.parameter)
      .then((response) => {      
           if (response.status == "200") {              
                this.items = response.data;  
                this.totalRows = this.items.length;    
                this.ShowMessageIsEmpty = this.items.length === 0 ? true : false;        
                this.$emit('load', false);
           }
           this.$emit('load', false);
      })
      .catch(error => {
        this.$emit('load', false);
        if (error.response) {
          this.showMessage(this.$tc('Msg.Error'),error,"error");
        }
      });  
    },

    PerPageFunction(perpage){
        this.perPage = perpage;  
        this.currentPage = 1;
      //  this.SearchAppTypes();   
    },

    pageChanged(page){
        this.currentPage = page;    
       // this.SearchAppTypes();   
    },

    IconSelected(){

    },
     onRowSelected(){ 
     this.SelectedRecords = 0;
     if(this.items.length > 0){
    for(var i = 0; i < this.items.length; i++){
      if(this.items[i].selected){
        this.SelectedRecords++;
      }
    }
     }
    },
    SelectAllRecords(){
      this.SelectedPage = this.items.length;
      this.wasSelectedAll = true;
    },
     onChangeSelectAll(v){
        if(v){
        this.SelectedRecords = this.items.length; 
        for(var i = 0 ; i < this.items.length; i++){
           this.$set(this.items[i], 'selected', true); 
        }
      }else{
        this.SelectedRecords = 0;
        for(var j= 0 ; j < this.items.length; j++){
           this.$set(this.items[j], 'selected', false); 
        }
      }
    },

    RowClicked(item,index,event){
        this.indexSelected = index;
       
     
    if(event.target.getAttribute('btn') === null){
        if(item.selected){      
          this.$set(item, 'selected', false);         
        }else{
          this.$set(item, 'selected', true);       
        }
        EventBus.$emit('rowClicked', item);
    }
        
    },
  },
  async created(){
     await this.getProviders();
      this.getNotesList();
     EventBus.$on("rowClicked", function () {        
        this.SelectedRecords = 0;
            for(var i = 0; i < this.items.length; i++){
                if(this.items[i].selected){
                    this.SelectedRecords++;
                }
            }      
     }.bind(this));
  },
  mounted(){
   
  }   
};
</script>


